import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

/**
 * useVisibleColumns — filters a table column list down to the columns the
 * current user may see, per the admin-level `hiddenColumns` registry.
 *
 * Columns are default-visible: only columns explicitly listed in
 * hiddenColumns[pageKey][tableKey] are removed. Bypassed roles
 * (admin/superadmin/allModulesAllowed) always see every column.
 *
 * Usage:
 *   const visibleColumns = useVisibleColumns("employees", "employeeTable", employeeColumns);
 */
export function useVisibleColumns(pageKey, tableKey, columns) {
  const { isColumnVisible } = useAuth();

  return useMemo(
    () =>
      Array.isArray(columns)
        ? columns.filter((c) => isColumnVisible(pageKey, tableKey, c.key))
        : [],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [columns, pageKey, tableKey, isColumnVisible]
  );
}

export default useVisibleColumns;
